module.exports = __webpack_public_path__ + "static/media/study 210908.50e50f4b.png";